import { constants } from "../constant/constants";
import { HttpHelper } from "../helper/http-helper-service";
import { LocalStorageService } from "../helper/local-storage-service";
import _ from "lodash";
export default class commonApiService {
  static getDropdownAutocomplete(url: string, query: string) {
    const sep = url.includes("?") ? "&" : "?";
    const fullUrl = `${url}${sep}query=${query}`;
    return HttpHelper.getData(fullUrl, []);
  }

  static getNewToken = () => {
    return HttpHelper.getData(constants.getToken, {});
  };

  static validateIfUserLoggedIn = () => {
    return HttpHelper.postData(constants.validateIfUserLoggedIn, {});
  };

  public static HasAccessNew(module: string, feature: string): boolean {
    return commonApiService.HasAccess("/" + module + "/" + feature);
  }

  public static getEnumerations() {
    return HttpHelper.getData(constants.apiUrl.CommonUrls.getEnumerations);
  }

  static HasAccess = (domURL: string) => {
    let _jsonData = LocalStorageService.getItem(
      constants.localStorage.keys.rules,
    ) as string;
    if (_jsonData) {
      let _data = JSON.parse(_jsonData);

      const domUrlLower = domURL.toLowerCase();
      for (let icounter = 0; icounter < _data.rules.length; icounter++) {
        if (_data.rules[icounter].subject.endsWith("APIURL")) {
          const dataFound = _.filter(
            _data.rules[icounter].actions,
            function (matcharr) {
              return matcharr.toLowerCase() === domUrlLower;
            },
          )[0];

          if (dataFound) {
            return true;
          }
        }
      }
    }
    return false;
  };

  static GetVersion = () => {
    return HttpHelper.getData(window.checkVersionUrl, {});
  };

  static registerValidSW() {
    //let swUrl = "src/common/serviceworkers/service-worker.js";
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`)
      .then((registration) => {
        console.log("service worker registered: ");
        console.log(registration);
      })
      .catch((error) => {
        console.error("Error during service worker registration:", error);
      });
  }
}
